import React, { FC, useState, useEffect } from 'react'
import { Button, Table, Input, Row, Col, Form, Upload, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { ISupplierContractDetails } from '../../../supplierTypes'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { useSupplierDetailsMode } from '../supplierDetailsModel'
import { useSupplyDetailsMode } from './supplierContractModel'
import { importPropsConfig } from '@/utils/importFile'
import { SupplyDetailsModal } from './supplierContractDetail'


export const SupplierContract: FC<RouterParamType> = ({ id, mode }) => {
    const { editFormVal } = useSupplierDetailsMode()
    const { dataSource, pgCfg, loading, loadData, supplierRef, handleInsert, handleEdit, ontractStatusOptions, handleDelete, changeContractStatus } = useSupplyDetailsMode()

    useEffect(() => {
        if (editFormVal.code) {
            supplierRef.current ={
                code: editFormVal.code,
                name: editFormVal.name
            }
            loadData()
        }
    }, [editFormVal.code])

    // 表格列定义
    const columns: ColumnsType<ISupplierContractDetails> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => (pgCfg.current! - 1) * pgCfg.pageSize! + i + 1,
        },
        {
            title: '状态',
            width: 140,
            dataIndex: 'status',
            fixed: 'left',
            render: (t: any, r: any, i: number) => {
                const item = ontractStatusOptions.find((item) => item.value === t)
                return item?.label || ''
            }
        },
         {
            title: '合同编号',
            width: 140,
            dataIndex: 'contractCode',
        },
        {
            title: '供应商编号',
            width: 140,
            dataIndex: 'supplierCode',
        },
        {
            title: '合同类型',
            width: 120,
            dataIndex: 'contractType',
        },
        {
            title: '甲方签约人',
            width: 100,
            dataIndex: 'partyASigner',
        },
        {
            title: '乙方签约人',
            width: 120,
            dataIndex: 'partyBSigner',
        },
        {
            title: '签约时间',
            width: 120,
            dataIndex: 'signDate',
        },
        {
            title: '有效期(天)',
            width: 120,
            dataIndex: 'validityDays',
        },
        {
            title: '截止日期',
            width: 120,
            dataIndex: 'deadline',
        },
        {
            title: '操作',
            width: 240,
            dataIndex: 'supplyQuantity',
            fixed: 'right',
            render: (t: Event, r: ISupplierContractDetails, i: number) => (
                <>
                    <span className="mr-10" onClick={() => {handleEdit(r)}}>
                        编辑
                    </span>
                     <span className="mr-10 color-red" onClick={() => {
                        handleDelete(r)
                     }}>
                        删除
                    </span>
                   {
                    r.status === 0 && (
                        <span className="mr-10 color-red" onClick={() => {
                            changeContractStatus(r, 1)
                        }}>
                            终止合同
                        </span>
                    )
                   }
                   {
                    r.status === 1 && (
                        <span className="mr-10" onClick={() => {
                            changeContractStatus(r, 0)
                        }}>
                            合同生效
                        </span>
                    )
                   }
                </>
            ),
        },
    ]

   
    const action = (
        <>
            <Button className="mr-5" type="link" shape="round" onClick={handleInsert}>
                新增
            </Button>
        </>
    )

    return (
        <YhBox style={{ padding: '20px' }} action={action}>
            <Table
                rowKey={(record) => record.id}
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomCenter'],
                    showTotal: (total) => `共${total}条`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                }}
                scroll={{ x: 'max-content', y: '400px' }}
            />
            <SupplyDetailsModal />
        </YhBox>
    )
}
